import { Box, Button, Paper, Typography, Link } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { Link as ReactRouterLink } from 'react-router-dom'
import { buildTimeStringFromTimestamp } from '../../../../../components/common/time/timeHelper'
import { SessionStatusBadge } from '../../../components/SessionStatusBadge'
import styles from './styles.module.scss'

export const SessionsTable = ({ sessions, onCreateSession, loading }) => {
  const { t } = useTranslation(['common', 'messages'])

  const columns = [
    {
      field: 'sessionId',
      headerName: 'Session ID',
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ row }) => {
        return <Typography variant="body2">{row.sessionId || '---'}</Typography>
      },
    },
    {
      field: 'status',
      headerName: t('common:status'),
      flex: 0.7,
      minWidth: 120,
      renderCell: ({ row }) => {
        return <SessionStatusBadge status={row.status} />
      },
    },
    {
      field: 'createdAt',
      headerName: t('common:createdAt'),
      flex: 0.8,
      minWidth: 150,
      sortable: false,
      renderCell: ({ row }) => {
        return <Typography variant="number">{buildTimeStringFromTimestamp(row.createdAt)}</Typography>
      },
    },
    {
      field: 'completedAt',
      headerName: t('common:completedAt'),
      flex: 0.8,
      minWidth: 150,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Typography variant="number">
            {row.completedAt ? buildTimeStringFromTimestamp(row.completedAt) : '---'}
          </Typography>
        )
      },
    },
    {
      field: 'actions',
      headerName: '',
      flex: 0.7,
      sortable: false,
      renderCell: ({ row }) => (
        <Link component={ReactRouterLink} title={row._id} to={`/kycv2/session/${row._id}`}>
          {t('common:viewDetails')}
        </Link>
      ),
    },
  ]

  return (
    <Paper elevation={0} className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h5">{t('common:sessions')}</Typography>
        <Button variant="contained" size="small" onClick={onCreateSession}>
          {t('common:createSession')}
        </Button>
      </Box>
      <DataGrid
        getRowId={(row) => row._id}
        rows={sessions || []}
        columns={columns}
        hideFooter={true}
        autoHeight={true}
        loading={loading}
      />
    </Paper>
  )
}
